var excludeFromBatch = ['refreshArlo'];
function batchKey(operation) {
  var operationName = operation.operationName;
  if (excludeFromBatch.includes(operationName)) {
    return operationName;
  }
  return '';
}

export { batchKey as default };
